import { ReactElement } from "react";
import { DateTime } from "@twiliointernal/e2-commons-shared-utils";

import { ChatBookend, ChatBookendItem } from "@twilio-paste/core/chat-log";

import { copy, BookendProps, MESSAGE_TIME_FORMAT } from "../../definitions";

/**
 * Bookends are for when the chat starts, ends, and the day when the chat spans multiple days.
 *  - Serve only as sub-component of <ChatLog />, thus copy is not exposed as props to enforce strict wordings.
 *  - If further use case (or types of bookend) is needed, adjust below code accordingly.
 */
const Bookend = ({
  dateCreated,
  type = "started",
}: BookendProps): ReactElement => {
  const dateTime = dateCreated && new DateTime(dateCreated);
  // 'Today' | 'Yesterday' | 'This week' | ...etc,
  const relativeTimeFromToday = dateTime?.getRelativeTimeFromToday();
  const timeCreated = dateTime?.format(MESSAGE_TIME_FORMAT);
  // TODO: Only one bookend type for now, removing object accessor via `type`
  const displayText = copy.bookend.started;

  return (
    <ChatBookend>
      <ChatBookendItem>{relativeTimeFromToday}</ChatBookendItem>
      <ChatBookendItem>
        <strong>{displayText}</strong> ・ {timeCreated}
      </ChatBookendItem>
    </ChatBookend>
  );
};

export default Bookend;
